module.exports = __webpack_public_path__ + "img/abnormal_notification_White.33db35d5.svg";